import React, { useState } from "react";
import { PiChats, PiPhoneCall } from "react-icons/pi";
import { FaRegCirclePause } from "react-icons/fa6";
import { BsFillMicMuteFill } from "react-icons/bs";
import { IoMdKeypad } from "react-icons/io";
import { MdCallEnd } from "react-icons/md";
import { SlCallOut } from "react-icons/sl";
import { IoClose } from "react-icons/io5";
import { VscCallIncoming, VscCallOutgoing } from "react-icons/vsc";

import Accordion from "react-bootstrap/Accordion";

const CallScreen = () => {
  const [activitie, setActivitie] = useState();

  const toggleActivitie = () => {
    setActivitie(!activitie);
  };

  return (
    <>
      <div className="arjun">
        <div className="dialBox p-4">
          <div className={`${activitie ? "active" : ""} activitieScree`}>
            <h4 className="closeTitle d-flex justify-content-between">
              Activities
              <button onClick={toggleActivitie} className="close">
                <IoClose />
              </button>
            </h4>

            <div className="p-4">
              <div className="cstAccordion">
                <Accordion defaultActiveKey="0" flush>
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      <span className="callIcon">
                        <VscCallOutgoing />
                      </span>{" "}
                      18 November, 10:30 PM
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>
                        <b className="d-block">Customer:</b>Hi, I've heard a lot about Greymatterz
                        and your expertise in AI. I run a mid level business, and I'm struggling to
                        reach the right audience online. Can you help me?
                      </p>
                      <p>
                        <b className="d-block">Digital Marketing Manager:</b> Hi! Thank you for
                        reaching out to us. We'd love to help. Could you tell me a bit more about
                        your business and the challenges you're facing in digital marketing?
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>
                      <span className="callIcon">
                        <VscCallIncoming />
                      </span>{" "}
                      16 November, 10:30 PM
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>
                        <b className="d-block">Digital Marketing Manager:</b> Hi! Thank you for
                        reaching out to us. We'd love to help. Could you tell me a bit more about
                        your business and the challenges you're facing in digital marketing?
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="2">
                    <Accordion.Header>
                      <span className="callIcon">
                        <VscCallOutgoing />
                      </span>{" "}
                      18 November, 10:30 PM
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>
                        <b className="d-block">Digital Marketing Manager:</b> Hi! Thank you for
                        reaching out to us. We'd love to help. Could you tell me a bit more about
                        your business and the challenges you're facing in digital marketing?
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            </div>
          </div>

          <div className="mb-4">
            <button className="activitieBtn" onClick={toggleActivitie}>
              <span className="me-2">
                <PiChats />
              </span>
              Activities
            </button>
          </div>

          <div className="callBox">
            <span className="icon">
              <PiPhoneCall />
            </span>
            <p className="number mt-3 mb-2">+91-9811852089</p>
            <p className="callTime">00:00:41</p>
          </div>

          <button className="callTransfer mx-auto">
            <SlCallOut /> Transfer Call
          </button>

          <div className="callRunSec">
            <div className="iconOpt mb-3">
              <button className="icon">
                <FaRegCirclePause />
                <p>Hold</p>
              </button>
              <button className="icon">
                <BsFillMicMuteFill />
                <p>Mute</p>
              </button>
              <button className="icon">
                <IoMdKeypad />
                <p>Keypad</p>
              </button>
            </div>
            <span className="callEndIcon">
              <MdCallEnd />
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default CallScreen;
